var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-loader"},[(!_vm.user_loaded)?_c('v-progress-circular',{attrs:{"indeterminate":true,"size":"50"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }